import { Card, Typography, TextField, DialogActions, Button, Divider, Box, Stack } from "@mui/material";
import Editor from "../../ckeditor/editor";
import { useEffect, useState } from "react";
import api from "../../services/api";
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import ListaVazia from "../../utils/listaVazia";
import Loading from "../../load/loading";
import DateHora from "../../utils/dateHora";
import MessageAlert from '../../messages/messageAlert';
import LoadingBackdrop from '../../load/loadingBackdrop';
import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import VerTodasObservacoes from "../departamentos/dlif/verTodasObservacoes";
import PrintIcon from '@mui/icons-material/Print';
import printerService from "../../services/printer";


const useStyles = () => ({
    page: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        padding: '8px 0 12px',
    },
    section: {
        background: '#fff',
        border: '1px solid #f2e0f4',
        borderRadius: 18,
        boxShadow: '0 10px 24px rgba(133, 40, 125, 0.08)',
        padding: 20,
    },
    listCard: {
        textDecoration: 'none',
        border: '1px solid #f2e0f4',
        borderLeft: '4px solid #85287d',
        borderRadius: 14,
        padding: '18px 20px',
        background: '#fff',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.03)',
        '&:hover': {
            background: '#faf3fb',
            transform: 'translateY(-2px)',
            boxShadow: '0 12px 24px rgba(133, 40, 125, 0.12)',
        },
    },
    label: {
        color: '#85287d',
        fontWeight: 700,
        marginRight: 6,
    },
    meta: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        marginTop: 10,
        fontSize: 13,
        color: '#5b5b5b',
    },
    descriptionPreview: {
        marginTop: 12,
        color: '#4f4f4f',
        fontSize: 14,
        lineHeight: 1.6,
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    title: {
        fontSize: 22,
        fontWeight: 700,
        color: '#4b204d',
        marginBottom: 8,
    },
    subtitle: {
        fontSize: 14,
        color: '#6b4f6c',
        marginBottom: 16,
        fontWeight: 600,
        letterSpacing: '0.02em',
    },
    actionButton: {
        background: 'linear-gradient(135deg, #85287d 0%, #ad4ea3 100%)',
        color: '#fff',
        borderRadius: 12,
        padding: '10px 22px',
        fontWeight: 700,
        boxShadow: '0 10px 18px rgba(133, 40, 125, 0.2)',
        '&:hover': {
            background: 'linear-gradient(135deg, #6f1e6e 0%, #993c8f 100%)',
        },
    },
    previewHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
        marginBottom: 12,
    },
    previewBody: {
        padding: '8px 4px 0',
        color: '#2d2d2d',
        lineHeight: 1.8,
    },
});

export default function Observacoes() {
    const classes = useStyles()
    const { id } = useParams()
    const user = useSelector(state => state.account.user);
    const [observacoesFeitas, setobservacoesFeitas] = useState('');
    const [observacao, setobservacao] = useState('');
    const [viewObservacao, setViewObservacao] = useState('')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState('');
    // console.log(observacao)

    useEffect(() => {
        api.get(`/observacaos?estabelecimentoId=${id}`)
            .then(response => {
                setobservacoesFeitas(response.data.observacaos);
            }).catch(err => '')
    }, [id, refresh])

    // function HandleChange(e) {
    //     e.target.files ?
    //         setobservacao({ ...observacao, [e.target.name]: e.target.files[0] })
    //         :
    //         setobservacao({ ...observacao, [e.target.name]: e.target.value })
    // }

    async function HandleCreateobservacao() {
        setLoading(true)
        setRefresh(false)
        setMessageError('')
        setMessageSuccess('')

        await api.post('/observacao/create', { ...observacao, 'userId': user._id, 'estabelecimentoId': id })
            .then(res => {
                setRefresh(true)
                setobservacao({ ...observacao, descricao: '', assunto: '' })
                setLoading(false)
                setMessageSuccess(res.data.msg)

            }).catch(error => {

                setMessageError(error.response.data.message)
                setLoading(false)
            })
    }

    const exportToPDF = (viewObservacaoId) => {
        printerService.printer(viewObservacaoId)
    }

    return (
        <>
            {viewObservacao ?
                <Card style={{ ...classes.section, position: 'relative' }}>
                    <Box style={classes.previewHeader}>
                        <Box />
                        <Stack direction="row" spacing={1}>
                            <IconButton size="small" onClick={() => setViewObservacao(null)} aria-label="Fechar observação"><CloseIcon /></IconButton>
                            <IconButton onClick={() => exportToPDF(viewObservacao._id)} aria-label="Imprimir observação"><PrintIcon /></IconButton>
                        </Stack>
                    </Box>

                    <div id={viewObservacao._id} style={classes.previewBody}>
                        <Typography variant="h5" style={{ lineHeight: 1.5, fontSize: 22, fontWeight: 700, color: '#4b204d', marginBottom: 10 }}>
                            Observação de: {viewObservacao.admin?.dadosPessoais.nome}
                        </Typography>
                        <Divider />
                        <Typography variant="body1" style={{ marginTop: 12, marginBottom: 8, fontWeight: 600, color: '#5a335f' }}>
                            Assunto: {viewObservacao.assunto}
                        </Typography>
                        <div dangerouslySetInnerHTML={{ __html: viewObservacao.descricao }} />
                        <Typography variant="caption" style={{ display: 'block', marginTop: 18, color: '#6d6d6d' }}>
                            Aos: <DateHora date={viewObservacao.updatedAt} />
                        </Typography>
                    </div>
                </Card>
                :
                <Box style={classes.page}>
                    {observacoesFeitas ?
                        <>
                            <VerTodasObservacoes img={true} observacoesFeitas={observacoesFeitas} />

                            <Box style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                {observacoesFeitas.length > 0 ?
                                    observacoesFeitas.map((observacao) => {
                                        const descricaoPreview = (observacao.descricao || '').replace(/<[^>]*>/g, '').trim();
                                        const textoResumo = descricaoPreview.length > 140 ? `${descricaoPreview.substring(0, 140)}...` : descricaoPreview;

                                        return (
                                            <Card key={observacao._id} style={classes.listCard} onClick={() => setViewObservacao(observacao)}>
                                                <Typography variant="h6" style={{ fontWeight: 700, color: '#4b204d', marginBottom: 8 }}>
                                                    {observacao.assunto}
                                                </Typography>

                                                {textoResumo && (
                                                    <Typography style={classes.descriptionPreview}>
                                                        {textoResumo}
                                                    </Typography>
                                                )}

                                                <Box style={classes.meta}>
                                                    <span><span style={classes.label}>Usuário:</span> {observacao.admin?.dadosPessoais.nome}</span>
                                                    <span><span style={classes.label}>Data:</span> <DateHora date={observacao.createdAt} /></span>
                                                </Box>
                                            </Card>
                                        );
                                    })
                                    :
                                    <Box style={classes.section}>
                                        <ListaVazia text={'Nenhuma observação encontrada.'} />
                                    </Box>
                                }
                            </Box>
                        </>
                        :
                        <Loading text={'Buscando observações'} />
                    }

                    <Card style={{ ...classes.section, minHeight: '40vh' }}>
                        <LoadingBackdrop open={loading} text={'A salvar observação'} />
                        {messageSuccess && <MessageAlert message={messageSuccess} type={'success'} />}
                        {messageError && <MessageAlert message={messageError} type={'error'} />}

                        <Typography variant="h5" style={classes.title}>
                            Descreva qualquer observação a ser feita sobre o estabelecimento.
                        </Typography>
                        <Typography style={classes.subtitle}>
                            Registe detalhes relevantes para acompanhamento e revisão.
                        </Typography>

                        <TextField
                            margin='dense'
                            type="text"
                            label="Assunto"
                            fullWidth
                            size="small"
                            name="assunto"
                            variant="outlined"
                            onChange={(e) => setobservacao({ ...observacao, assunto: e.target.value })}
                            value={observacao?.assunto || ''}
                            style={{ marginBottom: 12 }}
                        />

                        {/* EDITOR DE TEXTO CKEditor*/}
                        <Box style={{ marginTop: 8 }}>
                            <Editor
                                editorData={observacao?.descricao}
                                setEditorData={setobservacao}
                            />
                        </Box>

                        <DialogActions style={{ justifyContent: 'flex-end', paddingRight: 0, marginTop: 16 }}>
                            <Button onClick={HandleCreateobservacao} disabled={!observacao?.descricao} variant="contained" style={classes.actionButton}>
                                Salvar
                            </Button>
                        </DialogActions>
                    </Card>
                </Box>
            }
        </>
    )
}